// extracted by mini-css-extract-plugin
export default {"coordinatorScreen":"CoordinatorScreen_coordinatorScreen__VxsDU","screenContent":"CoordinatorScreen_screenContent__aB9GE","storyContent":"CoordinatorScreen_storyContent__KkIse"};